const storageInfo = {
  endpoint: `https://kr.object.ncloudstorage.com`,
  region: `kr-standard`,
  access_key: `bu5MBKAsrVwJL5DuaxUR`,
  secret_key: `KFJ3E7335jUiaCxWPTNoo9ypzkOdjdNxv03Qn41S`,
  bucket_name: `ubidtx01`,
  root_folder: `ubi01/`,
};

export default storageInfo;
